import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLandingTheme } from '../hooks/useLandingTheme';

const BottomCta: React.FC = () => {
  const { t } = useTranslation();
  const isDark = useLandingTheme();

  return (
    <section
      className={`py-16 md:py-32 ${isDark ? 'hero-bg-dark' : ''}`}
      style={{
        ...(!isDark ? { background: '#F8FAFC' } : {}),
      }}
    >
      <div
        className="max-w-[1200px] mx-auto px-6 lg:px-0 flex flex-col items-center"
        style={{ gap: '48px' }}
      >
        {/* Header */}
        <div className="w-full flex flex-col items-center" style={{ gap: '16px' }}>
          {/* Title row: "Ready to grow your Instagram on" + "autopilot" + "?" */}
          <h2
            className="flex flex-row justify-center items-center flex-wrap font-geist text-center text-[28px] leading-[34px] md:text-[48px] md:leading-[48px]"
            style={{
              fontWeight: 600,
              color: isDark ? '#FFFFFF' : '#314158',
              gap: '0px',
              margin: 0,
            }}
          >
            <span>{t('landing.bottomCta.titleBefore')}</span>
            <span className={isDark ? 'gradient-text-dark' : 'gradient-text'}>
              {t('landing.bottomCta.titleHighlight')}
            </span>
            <span>{t('landing.bottomCta.titleAfter')}</span>
          </h2>

          {/* Subtitle */}
          <p
            className="font-geist text-center text-base md:text-xl"
            style={{
              fontWeight: 400,
              lineHeight: '28px',
              color: isDark ? '#E2E8F0' : '#314158',
            }}
          >
            {t('landing.bottomCta.subtitle')}
          </p>
        </div>

        {/* CTA Button */}
        <Link
          to="/registration"
          className="gradient-btn inline-flex justify-center items-center bg-fc-gradient-btn text-white font-geist"
          style={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            padding: '12px 16px',
            borderRadius: '12px',
          }}
        >
          {t('landing.bottomCta.button')}
        </Link>
      </div>
    </section>
  );
};

export default BottomCta;
